import { ControlIcons } from 'owa-control-icons';
import type { BucketPayload } from 'owa-timestream-asset-sdk-bucket';
import {
    assetErrorBucket,
    bucketAssetName,
    bucketAssetTooltip,
} from './bucketStrings.locstring.json';
import { registerAsset, AssetAriaLabel } from 'owa-timestream-asset-sdk';
import loc from 'owa-localize';
import BucketView from './components/BucketView';
import * as styles from './components/styles.scss';

const BUCKET_TYPE = 'bucket';

export default registerAsset<BucketPayload>({
    type: BUCKET_TYPE,
    iconName: ControlIcons.OutlookSpacesBucket,
    getToolName: () => loc(bucketAssetName),
    getTooltip: () => loc(bucketAssetTooltip),
    getErrorMessage: () => loc(assetErrorBucket),
    unsupportedDefaultCommands: [],
    viewStyle: styles.bucketView,
    customRenderDueDate: true,
    customRenderOptions: true,
    optionsPosition: {
        top: 23,
        right: 23,
    },
    CanvasView: BucketView,
    createEmptyAsset: () => ({
        type: BUCKET_TYPE,
        payload: { name: '', charmId: 0 },
    }),
    getAriaLabel: (payload: BucketPayload) =>
        loc(AssetAriaLabel.assetAriaLabel, loc(bucketAssetName), payload.name ? payload.name : ''),
    getTitleString: getBucketName,
    getSearchString: getBucketName,
});

function getBucketName(payload: BucketPayload) {
    return payload.name;
}
